export const mapStateToProps = (state) => {
  return {
    bulkOrdersRead: state.warehouseState.bulkOrdersRead,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    reduxReadMassiveOrders: (payload) =>
      dispatch({
        type: "BULK_ORDERS_READER_REQUEST",
        value: payload,
      }),
    reduxDownloadBulkOrdersCSV: (payload) =>
      dispatch({
        type: "BULK_ORDERS_CSV_REQUEST",
        value: payload,
      }),
    reduxResetBulkOrdersReader: () =>
      dispatch({
        type: "BULK_ORDERS_READER_REQUEST_RESET",
      }),
  };
};
